import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, OnDestroy, OnInit } from '@angular/core';
import { ListHeaderComponent } from '@celerofinancas/common-domain';
import { CompanyService } from '@celerofinancas/service-utils';
import { CdsShimmerDirective } from '@celerofinancas/ui-directives';
import { BalanceWebsocketService } from '@shared/services/websockets/balance-websocket.service';
import { BehaviorSubject, filter, take } from 'rxjs';

/**
 * HeaderAccountsComponent
 * This component serves as a header for accounts, utilizing the ListHeaderComponent for display.
 */
@Component({
  selector: 'caixa-webcomponent-header-accounts',
  standalone: true,
  imports: [ListHeaderComponent, CdsShimmerDirective, AsyncPipe],
  providers: [BalanceWebsocketService],
  templateUrl: './header-accounts.component.html',
  styleUrls: ['./header-accounts.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderAccountsComponent implements OnInit, OnDestroy {
  /**
   * Company service
   */
  private company = inject(CompanyService);
  /**
   * Component loading
   */
  public componentLoading$ = new BehaviorSubject(true);

  /**
   * Balance WebSocket service for handling balance updates
   */
  private readonly balanceWebsocketService = inject(BalanceWebsocketService);

  /**
   * ngOnInit lifecycle hook
   */
  public ngOnInit(): void {
    this.handleComponentLoading();
    this.balanceWebsocketService.initialize();
  }

  /**
   * ngOnDestroy lifecycle hook for cleanup
   */
  public ngOnDestroy(): void {
    this.balanceWebsocketService.disconnect();
  }

  /**
   * Handles component loading and shimmer animation
   */
  private handleComponentLoading(): void {
    this.company
      .getComponentLoading()
      .pipe(
        filter((value) => !value),
        take(1),
      )
      .subscribe(() => {
        this.componentLoading$.next(false);
      });
  }
}
